import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

//api
const getCartapi = async (pageNumber, pageSize, search, field) => {
    try {
        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/cart?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        console.log("cart", res.data)
        return res.data
    } catch (err) {
        console.log(err.response?.data?.message);
        // toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const addToCartapi = async (product, sizeId, size_attributeId, quantity, color, selectedWeight) => {
    try {
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(`/cart`,
            {
                product, sizeId, size_attributeId, quantity, color, weight: selectedWeight
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const updateQuantityapi = async (cartItemId, quantity) => {
    try {
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(`/cart/update`,
            {
                cartItemId, quantity
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export {
    getCartapi,
    addToCartapi,
    updateQuantityapi
}
